/**
 * 自分ノートで任意に付けられる「気持ちタグ」の定義。
 *
 * 設計方針:
 * - 表示は Icon (lucide-react) + label の組み合わせ。
 *   PathNote の静かで優しい世界観に合わせ、絵文字ではなく線画アイコンを採用。
 * - 値（value）はノートに永続化される ID。表記揺れを避けるため英字。
 * - color は自分ログタブで時系列ドットの色などに使う。
 *   PathNote の "白の空気感、感情だけ暖色" 思想に沿って彩度は控えめ。
 *
 * 既存ノートで emotion を持たないものは null として扱う（後方互換）。
 *
 * アイコンスタイル統一:
 *   <Icon size={16} strokeWidth={1.5} color="..." />
 *   - 通常時 color: 中間グレー
 *   - 選択時 color: そのemotionのcolor
 */

import { Cloud, Lightbulb, Heart, Moon, Sprout, HelpCircle } from "lucide-react";

// 全色を彩度30〜40%帯にそろえて、ちぐはぐ感を防ぐ。
// 色相だけ各感情で変えて、優しい世界観を保つ。
// colorLight: グラデーション・アクセント用の薄い色（同色相で明度を上げたもの）。
// colorLighter: 極薄の単色背景用。カード左アイコンなど、面で淡く色を示したい箇所に使う。
export const EMOTIONS = [
  { value: "unease",  label: "モヤモヤ",   Icon: Cloud,      color: "#94A3B8", colorLight: "#C9D2DD", colorLighter: "#E5EBF2" }, // ブルーグレー
  { value: "insight", label: "気づき",     Icon: Lightbulb,  color: "#D9A56B", colorLight: "#F4DDB5", colorLighter: "#FBEFD8" }, // オレンジ
  { value: "joy",     label: "嬉しかった", Icon: Heart,      color: "#D88C8C", colorLight: "#F4C4C4", colorLighter: "#FBE2E2" }, // 赤橙
  { value: "tired",   label: "疲れた",     Icon: Moon,       color: "#7B8FAE", colorLight: "#B5C2D2", colorLighter: "#DAE2EC" }, // 静かなブルーグレー
  { value: "growth",  label: "成長",       Icon: Sprout,     color: "#8FB996", colorLight: "#C4D8C9", colorLighter: "#E0EBE3" }, // 若葉グリーン
  { value: "doubt",   label: "迷い",       Icon: HelpCircle, color: "#B5A7C7", colorLight: "#D8CFE2", colorLighter: "#ECE4F1" }, // ラベンダー
];

/** value -> entry の lookup */
export const EMOTION_MAP = Object.fromEntries(EMOTIONS.map(e => [e.value, e]));

/** 指定 value が有効かチェック */
export const isValidEmotion = (v) => v != null && EMOTION_MAP[v] != null;

/** 自分ログタブのフィルタータブ用：先頭の「すべて」を含む並び */
export const LOG_FILTERS = [
  { value: null, label: "すべて", Icon: null,    color: null },
  ...EMOTIONS.map(e => ({ value: e.value, label: e.label, Icon: e.Icon, color: e.color })),
];
